// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__2Qqhk","avatar":"Item_avatar__b7_OF","man":"Item_man__2ARc3","position":"Item_position__2N5eS"};